/**
 * Created by tmorone on 2/12/2016.
 */

var Marionette = require('backbone.marionette');

module.exports = Marionette.LayoutView.extend({
    template: require('../templates/LandingPage.html'),

    initialize: function() {
    }

});
